import { useParams } from "react-router-dom";
import React, { useState, useEffect, useContext } from "react";
import FormElement from "../components/FormBuilder/FormElement";
import { Grid, Paper, Box } from "@mui/material";
import { FormProvider } from "../FormContext";
import { fetchHHContractById } from "../api/contractVersionService";
import { fetchClientDetailData, processElement } from "../utils/formUtils";
import { AuthContext } from "../context/AuthContext";

const FormDownloadPage = (props) => {
  const { clientId, contractVersionId } = useParams();
  const [elements, setElements] = useState([]);
  const ToCaptureRef = React.useRef();
  const { auth } = useContext(AuthContext);

  const fieldMappings = {
    SubcontractorName: "SubcontractorName",
    FirstName: "FirstName",
    LastName: "LastName",
    Email: "Email",
    PersonalNo: "MobileNumber",
    Mobile: "MobileNumber",
    Address: "AddressLine1",
    City: "City",
    RecipientRole: "Subcontractor",
    Zipcode: "Postcode",
    ClientName: "ClientName",
    ClientAddress: "ClientAddress",
  };
  async function fetchData() {
    const [formData, clientData] = await Promise.all([
      fetchHHContractById(contractVersionId),
      fetchClientDetailData(clientId),
    ]);
    if (!formData || !clientData) return;
    if (clientData.ClientAddress) {
      clientData.ClientAddress = clientData.ClientAddress.replace(/\n/g, ", ");
    }
    const processList = (list) =>
      list.map((element) => {
        return processElement(element, clientData, fieldMappings);
      });
    const processedElements = processList(formData.MetaData);
    setElements(processedElements);
  }

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const token = urlParams.get('access_token');
    if (token) {
      if (urlParams.get('tempCode')) {
        localStorage.setItem("TempCode", urlParams.get('tempCode'));
        localStorage.setItem("Token", token);
        localStorage.setItem("Role", urlParams.get('role'));
      }
      auth.Token = token;
      auth.Email = urlParams.get('email');
      auth.Name = urlParams.get('name');
      auth.Role = urlParams.get('role');
      auth.TokenExpiry = urlParams.get('tokenExpiry');
      auth.UserId = urlParams.get('userId');
    }
    fetchData();
  }, []);

  const insertInlineCSS = () => {
    console.log("CSS insert invoked");
    const trackChangesClass = document.querySelectorAll(
      ".track-changes.added,.track-changes.deleted,.track-changes.modified"
    );
    if (trackChangesClass.length > 0) {
      console.log(trackChangesClass, "trackChangesClassAdded");
      trackChangesClass.forEach((element) => {
        element.classList.remove("track-changes");
      });
    }
    const commentClass = document.querySelectorAll(".selection-highlight");
    if (commentClass.length > 0) {
      commentClass.forEach((element) => {
        element.style.backgroundColor = "white";
        element.style.cursor = "none";
      });
    }
  };
  useEffect(() => {
    const handleLoad = () => {
      setTimeout(() => {
        if (elements.length > 0) {
          insertInlineCSS();
        }
      }, 1000); // 1 second delay
    };

    // Listen for the window load event to ensure the page is fully rendered
    if (document.readyState === "complete") {
      handleLoad(); // Page is already loaded
    } else {
      window.addEventListener("load", handleLoad); // Wait for the load event
    }

    // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener("load", handleLoad);
    };
  }, [elements]);

  return (
    <FormProvider>
      <Box
        position="relative"
        minHeight="100vh"
        sx={{
          backgroundColor: "#ffffffff",
        }}
      >
        <Grid container justifyContent="center" ref={ToCaptureRef}>
          <Grid item xs={12} md={8}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Paper elevation={3} sx={{ padding: 2, minHeight: "700px" }}>
                    <Grid container spacing={2}>
                      {elements.map((element, index) => (
                        <Grid
                          xs={12}
                          item
                          key={element.id}
                          sx={{
                            ...(element.type === "signature" ||
                              element.type === "fileUpload"
                              ? { pageBreakInside: "avoid" }
                              : {}),
                            ...(element.type === "logo" && {
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }),
                          }}
                        >
                          <FormElement
                            element={element}
                            dragHandle={false}
                            formPreview={true}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </FormProvider>
  );
};
export default FormDownloadPage;
